"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTokens = void 0;
const _ = require("lodash");
const replaceTokens = (str, data) => {
    // tokens are in the format {{obj.prop}}
    if (!str)
        return "";
    const tokens = str.match(/{{(.*?)}}/g);
    if (!tokens)
        return str;
    tokens.forEach((token) => {
        const token_key = token.replace("{{", "").replace("}}", "");
        const token_value = _.get(data, token_key);
        if (token_value) {
            str = str.replace(token, token_value);
        }
    });
    return str;
};
exports.replaceTokens = replaceTokens;
